/**
 * @file profile-view.tsx
 * @description
 * -----------------------------------------------------
 * Archivo que contiene la vista de perfil de usuario
 * -----------------------------------------------------
 * @version 0.0.1a
 * @created 2026-04-07
 * @author DLTCode
 * @author Sergio Manjón
 * @copyright © DLTCode
 * @license Private
 * */

"use client";

import { c as _c } from "react/compiler-runtime";
import { EditProfileModal, InfoProfileComponent, ChangePasswordModal, ProfileViewProvider, useProfileView } from "@/features/profile";
export const ProfileView = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ProfileViewProvider><Content /></ProfileViewProvider>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const Content = () => {
  const $ = _c(8);
  const {
    isEditProfileModalOpen,
    isChangePasswordModalOpen
  } = useProfileView();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <InfoProfileComponent />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isEditProfileModalOpen) {
    t1 = isEditProfileModalOpen && <EditProfileModal />;
    $[1] = isEditProfileModalOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isChangePasswordModalOpen) {
    t2 = isChangePasswordModalOpen && <ChangePasswordModal />;
    $[3] = isChangePasswordModalOpen;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t0}{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};